import {
  SectionElement,
  ButtonDesignType,
  ButtonDesignSize,
  ButtonActionType,
} from "@wuilt/section-preview";
import { nanoid } from "nanoid";
import type { OldButtonValue, ButtonSettingsExtended } from "./button-types";

const DESTINATION_MAPPER = (pageId: string, href: string) => ({
  internal: {
    type: ButtonActionType.Internal_Link,
    value: pageId,
  },
  external: {
    type: ButtonActionType.External_Link,
    value: href,
  },
});

function migrateSettings(
  id: string,
  old: OldButtonValue | ButtonSettingsExtended,
  designProps: {
    type?: ButtonDesignType;
    size?: ButtonDesignSize;
  }
): ButtonSettingsExtended {
  // has been migrated before
  if ((old as ButtonSettingsExtended).design)
    return old as ButtonSettingsExtended;

  const castedOld = old as OldButtonValue;

  return {
    id,
    text: castedOld.text,
    content: castedOld.text,
    action: {
      newTab: castedOld.target === "new",
      emailSubject: "",
      ...DESTINATION_MAPPER(castedOld.pageId, castedOld.href)[
        castedOld.destination
      ],
    },
    design: {
      type: designProps.type || ButtonDesignType.Primary,
      size: designProps.size || ButtonDesignSize.Large,
      borderRadius: 10,
      icon: "",
    },
    hidden: false,
  };
}

export function migrateElement(
  id: string,
  old: OldButtonValue | ButtonSettingsExtended,
  designProps: {
    type?: ButtonDesignType;
    size?: ButtonDesignSize;
  } = {}
): SectionElement {
  const settings = migrateSettings(id, old, designProps);

  return { id: id || `Button:${nanoid()}`, type: "Button", settings };
}
